const attributeNames = {
  SORT_BY: 'sortBy',
  SORT_ATTRIBUTE: 'sortAttribute',
  SORT_ORDER: 'sortOrder',
};

export default attributeNames;
